import { CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, Link, useModel, useParams } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import Nav from "components/shared/containers/Nav";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function MenuPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MenuPage
 */
export default function MenuPage(props) {
  let { menu } = useParams();
  menu = props.menuID?props.menuID:menu;


  return (
    <PageContainer className={`menu-page ${menu} ${props.className}`}>
    <ContentWrapper menuID={props.menuID}/>
    </PageContainer>
  );
}
function ContentWrapper(props){
  const { branding ,demos} = useModel();
  const { options } = branding;
  let { menu } = useParams();
  menu = props.menuID?props.menuID:menu;
  const [mabiMenu,setMabiMenu] =useState()
 
  let id = Util.inMabi ?"sideNav" :"respNav" ;
  let xml =  Nav(id)

  if(Util.inMabi && mabiMenu == undefined ){
   
    if(window.mabiMenu){
      setMabiMenu(window.mabiMenu)
    }
    
   } 
 
  useEffect(()=>{
   window.setTimeout(function(){ 
    if(Util.inMabi){

    setMabiMenu(window.mabiMenu)
   } 
   else{
   
      setMabiMenu(false)
   
    
   }
   },250)
  },mabiMenu)
  
  const  page = <CCTM nav-id={props.menuID??menu} xml={xml} self={Wrapper}>
              <CCTM_nav component={Wrapper}/>                            
              <CCTM_route component={PageLink}/>                  
              <CCTM_link component={PageLink}/> 
              <CCTM_item component={PageLink}/>   
              <CCTM_items component={LinkContainer}/>                     
              <CCTM_demo component={PageLink}  demos={demos}/>        
               <CCTM_subnav component={SubWrapper}/>              
          </CCTM>;
        
window.getCCTM = function(){
  return console.log(xml.querySelector("#"+menu+""));
}

  return  <PageContentView>
  <CenterContentContainer>
        
     {mabiMenu == undefined?<></>:page}
   
  </CenterContentContainer>
</PageContentView>
}

function SubWrapper(props){
  const { branding ,demos} = useModel();
  return <CCTM xml={props.currentNode} self={SubNav} data={props.data}>
           <CCTM_nav component={Wrapper}/>                            
          <CCTM_route component={PageLink}/>                  
          <CCTM_link component={PageLink}/> 
          <CCTM_item component={PageLink}/>   
          <CCTM_items component={LinkContainer}/>                     
          <CCTM_demo component={PageLink} demos={demos}/>        
          <CCTM_subnav component={SubWrapper}/>              
        </CCTM>
} 
function Wrapper(props){

const self = props.children?props.children[0]:props;
  return <div>
   
   <span className="hide">{self.id?self.id:""}</span>
    {props.children}
    </div>
} 
function SubNav(props){

  return <div className={"menu-page-header"}>
       <span className="hide">{props.id}</span>
      { props.asset_name && <SVGAsset id={props.asset_name} className={props["custom-class"] +" hide"}/>}  <ContentHeaderView text={props.label} />   
    {props.children}
    </div>
}



/**
 * @function LinkContainer
 * @return {React.Component}
 * @exported false
 * @description The default content for the profile page. 
 * Other bids may not use the same content, like the links.
 */
 function LinkContainer(props) {
  
  return (
 
    <div className={`flex-container flex-vertical menu-page-content `+ props["custom-class"]}>
       <span className="hide">{props.id}</span>
     {props.children}     
    </div>
  );
}
/**
 * @function PageLink
 * @return {React.Component}
 * @exported false
 * @description The default content for the profile page. 
 * Other bids may not use the same content, like the links.
 */
 function PageLink(props) {

   return    <div className="flex-height link-item">
             <span className="hide">{props.id}</span>{ props.asset_name && <SVGAsset id={props.asset_name} />}  <Link to={props.to}>{props.label}</Link>
            </div>
   


  
}